





























































































































































































































































































































































































































































































/* eslint-disable no-unused-vars */
import BaseForm from '@/views/BaseForm';
import { Component, Watch } from 'vue-property-decorator';
import { AxiosResponse } from 'axios';

import lineChartComponent from '@/components/chart/VueChart.vue';
import Chart from 'chart.js';
// import axios from 'axios';
/* eslint-enable no-unused-vars */
const FONT_COLOR = 'rgba(0, 0, 0, 1)';
const GRID_LINES_SETTING = {
    display: true,
    // drawOnChartArea: false,
    color: 'rgba(0, 0, 0, .07)',
    zeroLineColor: 'rgba(0, 0, 0, .3)',
};
const VIEWDAYNUM = 6;

@Component({
    name: 'event_list',
    components: { lineChartComponent },
    head: {
        title: {
            inner: 'バッテリ状態',
            separator: '-',
            complement: 'Battery-Surveillance',
        },
    },
})
export default class battery_chart extends BaseForm {
    private groupListData: any = []; // グループ一覧
    private selectGroup: number = 0; // 選択グループ
    private chartData: Chart.ChartData = {};
    private chartOptions: Chart.ChartOptions = {
        responsive: true,
        maintainAspectRatio: false,
        legend: {
            display: true,
            fullWidth: false,
            labels: {
                boxWidth: 20,
                fontColor: FONT_COLOR,
            },
            position: 'right',
        },
        layout: {
            padding: {
                top: 20,
                left: 20,
                bottom: 20,
                right: 20,
            },
        },
        scales: {
            xAxes: [
                {
                    gridLines: {
                        display: false,
                        // drawOnChartArea: false,
                    },
                    ticks: {
                        autoSkip: true,
                        maxTicksLimit: 28, //値の最大表示数
                        fontColor: FONT_COLOR,
                        fontSize: 14,
                    },
                    scaleLabel: {
                        display: true,
                        fontColor: FONT_COLOR,
                        labelString: '時',
                    },
                },
            ],
            yAxes: [
                {
                    id: 'yAxis_1',
                    type: 'linear',
                    gridLines: GRID_LINES_SETTING,
                    scaleLabel: {
                        display: true,
                        fontColor: FONT_COLOR,
                        labelString: '電圧(V)',
                    },
                    ticks: {
                        autoSkip: true,
                        fontColor: FONT_COLOR,
                        fontSize: 14,
                        min: 6,
                        max: 16,
                    },
                },
            ],
        },
    };
    private chartLabel: string[] = [];
    private arrDatePixel: any = [];
    private arrPref: any = [
        { name: '北海道', pref_num: 0 },
        { name: '青森県', pref_num: 1 },
        { name: '岩手県', pref_num: 2 },
        { name: '宮城県', pref_num: 3 },
        { name: '秋田県', pref_num: 4 },
        { name: '山形県', pref_num: 5 },
        { name: '福島県', pref_num: 6 },
        { name: '茨城県', pref_num: 7 },
        { name: '栃木県', pref_num: 8 },
        { name: '群馬県', pref_num: 9 },
        { name: '埼玉県', pref_num: 10 },
        { name: '千葉県', pref_num: 11 },
        { name: '東京都', pref_num: 12 },
        { name: '神奈川県', pref_num: 13 },
        { name: '新潟県', pref_num: 14 },
        { name: '富山県', pref_num: 15 },
        { name: '石川県', pref_num: 16 },
        { name: '福井県', pref_num: 17 },
        { name: '山梨県', pref_num: 18 },
        { name: '長野県', pref_num: 19 },
        { name: '岐阜県', pref_num: 20 },
        { name: '静岡県', pref_num: 21 },
        { name: '愛知県', pref_num: 22 },
        { name: '三重県', pref_num: 23 },
        { name: '滋賀県', pref_num: 24 },
        { name: '京都府', pref_num: 25 },
        { name: '大阪府', pref_num: 26 },
        { name: '兵庫県', pref_num: 27 },
        { name: '奈良県', pref_num: 28 },
        { name: '和歌山県', pref_num: 29 },
        { name: '鳥取県', pref_num: 30 },
        { name: '島根県', pref_num: 31 },
        { name: '岡山県', pref_num: 32 },
        { name: '広島県', pref_num: 33 },
        { name: '山口県', pref_num: 34 },
        { name: '徳島県', pref_num: 35 },
        { name: '香川県', pref_num: 36 },
        { name: '愛媛県', pref_num: 37 },
        { name: '高知県', pref_num: 38 },
        { name: '福岡県', pref_num: 39 },
        { name: '佐賀県', pref_num: 40 },
        { name: '長崎県', pref_num: 41 },
        { name: '熊本県', pref_num: 42 },
        { name: '大分県', pref_num: 43 },
        { name: '宮崎県', pref_num: 44 },
        { name: '鹿児島県', pref_num: 45 },
        { name: '沖縄県', pref_num: 46 },
    ];
    private selectPref: number = 0;
    private weatherData: any = [];
    private colorAngle: number[] = [0, 120, 240, 60, 180, 300, 30, 150, 270, 90, 210, 330];
    private colorcnt: number = 0;

    async created() {
        let arrIni: any = { icon: '' };
        for (let i = 0; i < 28; i++) {
            this.weatherData.push(arrIni);
        }
        this.createChartLabel();
        this.createChartData();
        await this.getGroupList();
        if (this.groupListData.length > 0) {
            this.selectGroup = this.groupListData[0]['group_id'];
            // this.selectPref = this.groupListData[0]['pref_num'];
        }
        // await this.getWeather(this.selectPref);
        this.getChartData(this.selectGroup);
    }
    private createChartLabel() {
        this.chartLabel = [];
        for (let i = VIEWDAYNUM; i >= 0; i--) {
            let dt_str = new Date();
            dt_str.setDate(dt_str.getDate() - i);
            for (let j = 0; j < 24; j++) {
                // 現在時間まで
                if (!(i == 0 && j > dt_str.getHours())) {
                    this.chartLabel.push(dt_str.getDate() + '日 ' + j + '時');
                }
            }
        }
    }
    async mounted() {
        // let table_witdh = this.arrDatePixel[0]['pixel'] + this.arrDatePixel[0]['width'] - this.arrDatePixel[6]['pixel'];
    }

    // グラフ初回表示時に天気用のテーブルの幅同期
    @Watch('arrDatePixel.length')
    private changeArrDatePixel() {
        let table_witdh = this.arrDatePixel[0]['pixel'] + this.arrDatePixel[0]['width'] - this.arrDatePixel[6]['pixel'];
        for (let i = 0; i < this.arrDatePixel.length; i++) {
            let el_th: any = document.getElementById('th-' + i);
            el_th.style.width = this.arrDatePixel[i]['width'] / table_witdh + '%';
        }
    }
    // 選択された県の天気を取得
    private async getWeather(pref: number) {
        try {
            // Loading画面を表示する
            this.$store.dispatch('common/setLoadingStateAc', true);
            const resp: AxiosResponse<any> = await this.$http.post(
                'getweather.php',
                {
                    pref_num: pref,
                },
                {
                    headers: { token: this.token },
                }
            );
            let cnt: number = 0;
            switch (resp.data.result) {
                case 'SUCCESS':
                case 'DATA_NOTFOUND_ERROR':
                    this.weatherData = resp.data.items;
                    for (let i = 0; i < 4; i++) {
                        if (this.weatherData[24 + i].icon != '') {
                            cnt++;
                        }
                    }
                    this.$nextTick(() => {
                        document
                            .getElementById('th-last-box')
                            ?.querySelectorAll('img')
                            .forEach((el: any) => {
                                el.style.width = 'calc(100% / ' + cnt + ')';
                            });
                    });
                    break;
                case 'AUTHORITY_ERROR':
                case 'DBCONNECTION_ERROR':
                    this.$store.dispatch('common/setAlertParamsAc', {
                        is_display: true,
                        type: 'error',
                        timeout: 5000,
                        message: 'データ取得失敗',
                        return_flg: false,
                    });
                    break;
            }
        } catch (error) {
            this.$store.dispatch('common/setAlertParamsAc', {
                is_display: true,
                type: 'error',
                timeout: 5000,
                message: '天気データ取得失敗',
                return_flg: false,
            });
        } finally {
            // Loading画面を非表示にする
            this.$store.dispatch('common/setLoadingStateAc', false);
        }
    }

    private getWeatherText(num: number) {
        let rtnText: string = '';
        if (this.weatherData[num].description) {
            rtnText += '天気：' + this.weatherData[num].description;
            let temp_min: string = '-';
            if (this.weatherData[num].temp_min != 0) {
                temp_min = String(Math.floor(this.weatherData[num].temp_min)) + '℃';
            }
            rtnText += '\n最低気温：' + temp_min;
            let temp_max: string = '-';
            if (this.weatherData[num].temp_max != 0) {
                temp_max = String(Math.floor(this.weatherData[num].temp_max)) + '℃';
            }
            rtnText += '\n最高気温：' + temp_max;
            let humidity: string = '-';
            if (this.weatherData[num].humidity != 0) {
                humidity = this.weatherData[num].humidity + '%';
            }
            rtnText += '\n湿度：' + humidity;
            let clouds: string = '-';
            if (this.weatherData[num].clouds != 0) {
                clouds = this.weatherData[num].clouds + '%';
            }
            rtnText += '\n雲量：' + clouds;
        } else {
            rtnText = 'データなし';
        }
        return rtnText;
    }
    // グループ一覧の取得
    private async getGroupList() {
        try {
            // Loading画面を表示する
            this.$store.dispatch('common/setLoadingStateAc', true);
            const resp: AxiosResponse<any> = await this.$http.post(
                'group_list.php',
                {
                    hide_all: true,
                },
                {
                    headers: { token: this.token },
                }
            );
            switch (resp.data.result) {
                case 'SUCCESS':
                case 'DATA_NOTFOUND_ERROR':
                    this.groupListData = resp.data.items;
                    break;
                case 'SESSION_ERROR':
                    this.$store.dispatch('common/setAlertParamsAc', {
                        is_display: true,
                        type: 'error',
                        timeout: 3000,
                        message: 'ログイン期限が終了しました。再度ログインして下さい。',
                        return_flg: true,
                    });
                    break;
                case 'AUTHORITY_ERROR':
                case 'DBCONNECTION_ERROR':
                    this.$store.dispatch('common/setAlertParamsAc', {
                        is_display: true,
                        type: 'error',
                        timeout: 5000,
                        message: 'データ取得失敗',
                        return_flg: false,
                    });
                    break;
            }
        } catch (error) {
            this.$store.dispatch('common/setAlertParamsAc', {
                is_display: true,
                type: 'error',
                timeout: 5000,
                message: 'データ取得失敗',
                return_flg: false,
            });
        } finally {
            // Loading画面を非表示にする
            this.$store.dispatch('common/setLoadingStateAc', false);
        }
    }

    // グラフ表示用データ取得
    private async getChartData(selectGroup: number) {
        try {
            // Loading画面を表示する
            this.$store.dispatch('common/setLoadingStateAc', true);
            let params: any = { group_id: selectGroup };
            const resp: AxiosResponse<any> = await this.$http.post('chart_data.php', params, {
                headers: { token: this.token },
            });
            switch (resp.data.result) {
                case 'SUCCESS':
                    this.createChartData(resp.data.items);
                    break;
                case 'DATA_NOTFOUND_ERROR':
                    this.$store.dispatch('common/setAlertParamsAc', {
                        is_display: true,
                        type: 'error',
                        timeout: 5000,
                        message: 'データがありません',
                        return_flg: false,
                    });
                    this.createChartData();
                    break;
                case 'SESSION_ERROR':
                    this.$store.dispatch('common/setAlertParamsAc', {
                        is_display: true,
                        type: 'error',
                        timeout: 3000,
                        message: 'ログイン期限が終了しました。再度ログインして下さい。',
                        return_flg: true,
                    });
                    break;
                case 'AUTHORITY_ERROR':
                case 'DBCONNECTION_ERROR':
                    this.$store.dispatch('common/setAlertParamsAc', {
                        is_display: true,
                        type: 'error',
                        timeout: 5000,
                        message: 'データ取得失敗',
                        return_flg: false,
                    });
                    break;
            }
        } catch (error) {
            this.$store.dispatch('common/setAlertParamsAc', {
                is_display: true,
                type: 'error',
                timeout: 5000,
                message: 'データ取得失敗',
                return_flg: false,
            });
        } finally {
            // Loading画面を非表示にする
            this.$store.dispatch('common/setLoadingStateAc', false);

            // 選択されたグループに設定されている地域を選択させる
            let idx: number = this.groupListData.findIndex(
                ({ group_id }: { group_id: number }) => group_id === selectGroup
            );
            if (this.groupListData[idx]['pref_num'] >= 0) {
                this.selectPref = Number(this.groupListData[idx]['pref_num']);
                this.getWeather(this.selectPref);
            }
        }
    }

    public createChartData(data: any = []) {
        let dataset: any = [];
        if (Object.keys(data).length) {
            for (let k of Object.keys(data)) {
                let color = this.getColor();
                dataset.push({
                    yAxisID: 'yAxis_1',
                    type: 'line',
                    label: data[k]['info']['control_number'],
                    backgroundColor: color,
                    borderColor: color,
                    fill: false,
                    data: data[k]['data'],
                });
            }
        } else {
            dataset.push({
                yAxisID: 'yAxis_1',
                type: 'line',
                label: 'sample1',
                backgroundColor: '#6090EF',
                borderColor: '#6090EF',
                fill: false,
                data: this.craeteRamdomValue(),
            });
        }
        // this.chartData = Object.assign({});
        this.$set(this.chartData, 'labels', this.chartLabel);
        this.$set(this.chartData, 'datasets', dataset);
        this.chartData = Object.assign({}, this.chartData);
    }

    // csv出力
    private async onClickOutPutCsv() {
        try {
            // Loading画面を表示する
            this.$store.dispatch('common/setLoadingStateAc', true);
            let params: any = { group_id: this.selectGroup };
            const resp: AxiosResponse<any> = await this.$http.post('chart_data_csv.php', params, {
                headers: { token: this.token },
            });
            switch (resp.data.result) {
                case 'SUCCESS':
                    this.csvFileDownload(resp.data.filename);
                    break;
                case 'DATA_NOTFOUND_ERROR':
                    this.$store.dispatch('common/setAlertParamsAc', {
                        is_display: true,
                        type: 'error',
                        timeout: 5000,
                        message: 'データがありません',
                        return_flg: false,
                    });
                    this.createChartData();
                    break;
                case 'SESSION_ERROR':
                    this.$store.dispatch('common/setAlertParamsAc', {
                        is_display: true,
                        type: 'error',
                        timeout: 3000,
                        message: 'ログイン期限が終了しました。再度ログインして下さい。',
                        return_flg: true,
                    });
                    break;
                case 'AUTHORITY_ERROR':
                case 'DBCONNECTION_ERROR':
                    this.$store.dispatch('common/setAlertParamsAc', {
                        is_display: true,
                        type: 'error',
                        timeout: 5000,
                        message: 'データ取得失敗',
                        return_flg: false,
                    });
                    break;
            }
        } catch (error) {
            this.$store.dispatch('common/setAlertParamsAc', {
                is_display: true,
                type: 'error',
                timeout: 5000,
                message: 'csv作成に失敗しました',
                return_flg: false,
            });
        } finally {
            // Loading画面を非表示にする
            this.$store.dispatch('common/setLoadingStateAc', false);
        }
    }

    // 作成されたcsvファイルをダウンロード
    private async csvFileDownload(filename: string) {
        let date = new Date();
        let downFileName =
            date.getFullYear() +
            ('0' + (date.getMonth() + 1)).slice(-2) +
            ('0' + date.getDate()).slice(-2) +
            ('0' + date.getHours()).slice(-2) +
            ('0' + date.getMinutes()).slice(-2) +
            ('0' + date.getSeconds()).slice(-2) +
            '_chartdata.csv';
        this.$httpfile
            .get(filename, {
                responseType: 'blob',
            })
            .then(res => {
                let blob = window.URL.createObjectURL(new Blob([res.data]));
                let link = document.createElement('a');
                link.href = blob;
                link.download = downFileName;
                link.click();
                return true;
            })
            .catch((err: any) => {
                //エラー出力
                alert('PDFダウンロード失敗');
                return false;
            });
    }

    private getColor() {
        // // 色はHue（色相）を変化させる。
        // // Saturation（彩度）とLightness（輝度）は固定。
        // const h = Math.random() * 360;
        // return `hsl(${h}, 80%, 60%)`;
        const h = this.colorAngle[this.colorcnt];
        this.colorAngle[this.colorcnt] += 32;
        if (this.colorAngle[this.colorcnt] >= 360) {
            this.colorAngle[this.colorcnt] -= 360;
        }
        this.colorcnt++;
        if (this.colorcnt >= 12) {
            this.colorcnt = 0;
        }
        return `hsl(${h}, 80%, 60%)`;
    }
    private craeteRamdomValue() {
        const arr: number[] = [];
        for (let i = 0; i < 24; i++) {
            arr.push(0);
        }
        return arr;
    }

    // 背景色の描画
    private drawBackground(target: any): void {
        let xscale: any = target.scales['x-axis-0'];
        let yscale: any = target.scales['yAxis_1'];

        // 当日から1週間前の日付まで取得
        let now: Date = new Date();
        for (let i: number = 0; i < 7; i++) {
            let date: Date = new Date(now.getFullYear(), now.getMonth(), now.getDate() - i);
            this.$set(this.arrDatePixel, i, []);
            this.$set(this.arrDatePixel[i], 'day', date.getDate());
            this.$set(this.arrDatePixel[i], 'pixel', xscale.getPixelForValue(date.getDate() + '日 0時'));
        }

        let left: number = xscale.left;
        let right: number = xscale.right;
        let top: number = yscale.top;
        let height: number = yscale.height;

        let canvas: any = document.getElementById('battery_chart');
        let ctx: any = '';
        if (canvas.getContext) {
            ctx = canvas.getContext('2d');
            ctx.fillStyle = 'rgba(180, 180, 180, 0.1)';
            ctx.fillRect(this.arrDatePixel[0]['pixel'], top, right - this.arrDatePixel[0]['pixel'], height);
            ctx.fillRect(
                this.arrDatePixel[2]['pixel'],
                top,
                this.arrDatePixel[1]['pixel'] - this.arrDatePixel[2]['pixel'],
                height
            );
            ctx.fillRect(
                this.arrDatePixel[4]['pixel'],
                top,
                this.arrDatePixel[3]['pixel'] - this.arrDatePixel[4]['pixel'],
                height
            );
            ctx.fillRect(left, top, this.arrDatePixel[5]['pixel'] - left, height);
            ctx.fillStyle = 'rgba(255, 255, 255, .5)';
            ctx.fillRect(
                this.arrDatePixel[1]['pixel'],
                top,
                this.arrDatePixel[0]['pixel'] - this.arrDatePixel[1]['pixel'],
                height
            );
            ctx.fillRect(
                this.arrDatePixel[3]['pixel'],
                top,
                this.arrDatePixel[2]['pixel'] - this.arrDatePixel[3]['pixel'],
                height
            );
            ctx.fillRect(
                this.arrDatePixel[5]['pixel'],
                top,
                this.arrDatePixel[4]['pixel'] - this.arrDatePixel[5]['pixel'],
                height
            );
        }

        for (let j: number = 0; j < 6; j++) {
            this.$set(
                this.arrDatePixel[j + 1],
                'width',
                this.arrDatePixel[j]['pixel'] - this.arrDatePixel[j + 1]['pixel']
            );
        }
        this.$set(this.arrDatePixel[0], 'width', right - this.arrDatePixel[0]['pixel']);
        this.$set(this.arrDatePixel[6], 'width', this.arrDatePixel[5]['pixel'] - left);
    }
}
